module.exports = __webpack_public_path__ + "img/underground_on.77112183.svg";